import { toast } from "react-toastify"

export function download_csv(json, fileTitle) {
  if(json.length === 0 ){
    toast.warning("⚠️ Nenhum dado a ser exportado")
    return
  }
  
  const items = json

  const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
  const header = Object.keys(items[0])
  const csv = [
    header.join(';'), // header row first
    ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(';'))
  ].join('\r\n')

  let csvElement = document.createElement('a');  
  csvElement.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv);  
  csvElement.target = '_blank';  
  csvElement.download = `${fileTitle}.csv`; 
  csvElement.click();  
}